import { useState } from 'react'
import {
  ExpansionPanel as Expansion,
  ExpansionPanelContent,
  ExpansionPanelActionEvent,
} from "@progress/kendo-react-layout";
import { Reveal } from '@progress/kendo-react-animation';

interface IExpansionPanel {
  item: any;
  title: any;
  children: any;
  size?: "small" | "medium" | "large";
  fullwidth?: boolean;
  disabled?: boolean;
  className?: string;
}

const ExpansionPanel = (props: IExpansionPanel) => {
  const { item, title, children, size, fullwidth, disabled, className } = props;
  const [expanded, setExpanded] = useState<string>("");
  const [style] = useState<string>(fullwidth ? "100%" : size === "large" ? "70%" : size === "medium" ? "50%" : size === "small" ? "40%" : "40%")
  return (
    <Expansion
      title={title}
      subtitle={""}
      tabIndex={0}
      expanded={expanded === item.id}
      key={item.id}
      expandIcon='k-i-caret-alt-down'
      collapseIcon='k-i-caret-alt-up'
      onAction={(event: ExpansionPanelActionEvent) => {
        setExpanded(event.expanded ? "" : item.id)
      }}
      style={{ width: style, margin: '0px' }}
      disabled={disabled ?? false}
      className={className ?? ''}
    >
      <Reveal>
        {expanded === props.item.id ? (
          <ExpansionPanelContent>
            {children}
          </ExpansionPanelContent>
        ) : null}
      </Reveal>
    </Expansion>
  )
}

export default ExpansionPanel